export class OnboardingEnvironment {
  public static getName = () => 'benzinga-onboarding';
  public static getEnvironment = (env: Record<string, string>) => ({
    fastLinkConfig: env.fastLinkConfig,
    fastLinkUrl: env.fastLinkUrl,
    rootUrl: new URL(env.rootUrl ?? 'https://api.benzinga.com/'),
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
